import { observable } from 'mobx';
import sell from '../static/statement/line.jpg';
import avatar_fhh from '../static/sell/fhh.png';
import avatar_cxh from '../static/sell/cxh.png';
import avatar_chl from '../static/sell/chl.png';
import avatar_yzx from '../static/sell/yzx.png';
import avatar_lst from '../static/sell/lst.png';
import avatar_zgj from '../static/sell/zgj.png';
import avatar_lcy from '../static/sell/lcy.png';
import avatar_yyt from '../static/sell/yyt.png';
import avatar_cyy from '../static/sell/cyy.png';
import avatar_ljy from '../static/sell/ljy.png';


class SellMobx {
	@observable sellImg = sell;
	@observable avatar = avatar_cxh;
	@observable cards = [{
		avatar: avatar_fhh,
		name: '冯海鸿',
		phone: 18616303363
	}, {
		avatar: avatar_chl,
		name: '陈湖丽',
		phone: 13729705678
	}, {
		avatar: avatar_yzx,
		name: '严振熙',
		phone: 13030273672
	}, {
		avatar: avatar_lst,
		name: '梁诗挺',
		phone: 13257668816
	}, {
		avatar: avatar_zgj,
		name: '钟建国',
		phone: 18122477672
	}, {
		avatar: avatar_lcy,
		name: '梁彩英',
		phone: 15917155448
	},
		// {
		// 	avatar: avatar_cyy,
		// 	name: '陈永怡',
		// 	phone: 15521416656
		// }, 
		// {
		// 	avatar: avatar_yyt,
		// 	name: '叶樱彤',
		// 	phone: 13077558938
		// },  {
		// 	avatar: avatar_ljy,
		// 	name: '刘建英',
		// 	phone: 15016590882
		// }
	];
}

export default SellMobx;